import React, { useState } from 'react';
import { Question } from '@phosphor-icons/react';
import { motion, AnimatePresence } from 'framer-motion';
import HelpSupportModal from './HelpSupportModal';

const FloatingHelpButton = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {/* Floating Button */}
      <motion.button
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1, type: 'spring' }}
        onClick={() => setShowModal(true)}
        data-testid="floating-help-btn"
        className="fixed bottom-6 right-6 z-40 w-12 h-12 rounded-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 shadow-lg shadow-purple-500/25 flex items-center justify-center transition-all hover:scale-110 group"
        title="Need Help?"
      >
        <Question size={22} className="text-white" weight="bold" />
        
        {/* Tooltip */}
        <AnimatePresence>
          <motion.span 
            initial={{ opacity: 0, x: 10 }}
            whileHover={{ opacity: 1, x: 0 }}
            className="absolute right-14 px-2 py-1 bg-slate-800 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"
          >
            Need Help?
          </motion.span>
        </AnimatePresence>
      </motion.button>

      {/* Help Modal */}
      <HelpSupportModal 
        isOpen={showModal} 
        onClose={() => setShowModal(false)} 
      />
    </>
  );
};

export default FloatingHelpButton;
